module.exports = __webpack_public_path__ + "static/media/slider-track.21a2d5a5.png";